import {
  ODataHeader,
  ODataString,
  ODataEnum,
  ODataDate
} from "pbas-vue-components";
import { i18n } from '@/plugins/i18n';
import { translate } from "../trans";
import store from '@/store'

function getHeaders(enums) {
  const headers = [
    new ODataHeader({
      type: new ODataString("Id"),
      sortable: false,
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false
    }),
    new ODataHeader({
      type: new ODataString("PlanId"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false
    }),
    new ODataHeader({
      title: "globals.province",
      type: new ODataString("FeeGuide/Province/Translations[]/DisplayValue", {
        getString: item => {
          if (!item || !item.FeeGuide) return "";
          const lang = store.getters['common/language']
          return translate(item.FeeGuide.Province, lang.language);
        }
      }),
      sortable: false,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      type: new ODataString("FeeGuide/ProvinceId"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false
    }),
    new ODataHeader({
      type: new ODataString("FeeGuide/Province/Translations[]/LanguageCode"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false
    }),
    new ODataHeader({
      type: new ODataString("FeeGuide/Province/Id"),
      sortable: false,
      visible: false,
      searchable: false,
      allowVisibilityChange: false
    }),
    new ODataHeader({
      title: "components.guides.import_guide_dialog.geolocation",
      type: new ODataEnum("FeeGuide/GeoLocation", {
        getString: (item) => {
          if (!item || !item.FeeGuide) return "";
          return i18n.t("enums." + item.FeeGuide.GeoLocation);
        },
        dropdownItems: enums.PaymentMethod,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "headers.t4a.Year",
      type: new ODataString("FeeGuide/Year"),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      title: "globals.name",
      type: new ODataString("FeeGuide/Name"),
      sortable: true,
      visible: true,
      searchable: true
    }),
    new ODataHeader({
      title: "globals.effective_date",
      type: new ODataDate("EffectiveDate"),
      sortable: true,
      visible: true,
      searchable: true
    }),
  ];
  return headers;
}
export default getHeaders;
